import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { sendPostErrorClient } from './api';
import { ErrorMonitoringCheckEditor, ErrorMonitoringCheckHeaderV2 } from './check-handle/ErrorMonitoringCheckHeaderV2';

const globalClientMessageA: any = {};
export default function ErrorMonitoringCommon() {
    const { locale = 'us' } = useRouter();
    useEffect(() => {
        // 导航检查
        const initHandleHeaderV2 = async () => {
            if (typeof window === 'undefined') {
                return;
            }
            if (location.origin !== 'https://www.ecoflow.com') {
                return;
            }
            setTimeout(() => {
                try {
                    ErrorMonitoringCheckHeaderV2(locale);
                } catch (error) {}
                try {
                    ErrorMonitoringCheckEditor(locale);
                } catch (error) {}
            }, 3000);
        };

        const initHandleAll = async () => {
            initHandleHeaderV2();
        };
        initHandleAll();
    }, []);
    useEffect(() => {
        const initGlobalJsErrorHandle = (event: ErrorEvent) => {
            // 这些属性就是文件和行号
            const error_file = event.filename || '';
            const error_line = event.lineno || '';
            const error_col = event.colno || '';
            const error_message_1 = `${event.message || ''}`.slice(0, 1024);
            const error_message_b1 = `${event.error?.stack || ''}`;
            const error_message_2 = `${error_message_b1 + error_file + error_line + error_col}`.slice(0, 1024);

            if (globalClientMessageA[error_message_1]) {
                return;
            }
            globalClientMessageA[error_message_1] = true;
            const originA = location.origin || '';
            if (
                error_message_1.includes('twq') ||
                error_message_1.includes('currentEntry') ||
                error_message_1.includes('Script error.') ||
                error_message_1.includes('gtag') ||
                error_message_1.includes(`(reading 'indexOf')`) ||
                error_message_1.includes(`(reading ''indexOf'')`) ||
                error_message_1.includes('f.indexOf') ||
                error_message_1.includes(`Uncaught TypeError: Cannot read properties of undefined (reading ''replace'')`)
            ) {
                return;
            }
            // 只收集生产域名的
            if (originA.includes('https://www.ecoflow.com')) {
                sendPostErrorClient(locale, {
                    error_message_1,
                    error_message_2,
                });
            }
        };
        window.addEventListener('error', initGlobalJsErrorHandle);
        return () => {
            window.removeEventListener('error', initGlobalJsErrorHandle);
        };
    }, []);
    return null;
}
